// src/services/airQuality.js
// Shared utility for fetching Air Quality Index (AQI) data from AirNow.gov

/**
 * Fetches AQI data from AirNow.gov for the given latitude and longitude.
 * @param {number} lat - Latitude
 * @param {number} lng - Longitude
 * @param {string} [apiKey] - Optional API key override
 * @returns {Promise<object[]>} - Resolves to AQI data array
 * @throws {Error} - Throws error if fetch fails
 */
export async function fetchAQI(lat, lng, apiKey) {
  const API_KEY = apiKey || process.env.REACT_APP_AirNow_API_KEY;
  if (!API_KEY) throw new Error("Missing AirNow API key");
  const url = `https://www.airnowapi.org/aq/observation/latLong/current/?format=application/json&latitude=${lat}&longitude=${lng}&distance=25&API_KEY=${API_KEY}`;
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`Failed to get AQI: ${res.status}`);
  }
  return await res.json();
}
